import httpClient from "../../clients/httpClient";
import { IActiveAppStoreIssuesResponse } from "../../state/types/app-store-issues";

export const getActiveAppStoreIssues = () => {
    return httpClient.get<IActiveAppStoreIssuesResponse>(
        "/api/v1/app-store-issues/active"
    );
};
